var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "fullscreenExit-sl",
  "use": "fullscreenExit-sl-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fullscreenExit-sl\">\n    <path d=\"M0 0h48v48h-48z\" fill=\"none\" />\n    <path d=\"M10 32h6v6h4v-10h-10v4zm6-16h-6v4h10v-10h-4v6zm12 22h4v-6h6v-4h-10v10zm4-22v-6h-4v10h10v-4h-6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id